<template>
  <div class="active_works">
    <div class="active_works_search">
      <div class="works_search_one search">
        <p>赛道信息</p>
        <el-select v-model="activityWayUuid" placeholder="请选择" clearable @change="getTypeInfo">
          <el-option
                  v-for="item in wayList"
                  :key="item.uuid"
                  :label="item.name"
                  :value="item.uuid">
          </el-option>
        </el-select>
      </div>
      <div class="works_search_one">
        <p>作品类别</p>
        <el-select v-model="typeUuid" placeholder="请选择" clearable @change="search">
          <el-option
                  v-for="item in typeList"
                  :key="item.uuid"
                  :label="item.worksType"
                  :value="item.uuid">
          </el-option>
        </el-select>
      </div>
      <div class="works_search_two">
        <el-radio-group v-model="radio" size="small" @change="getOrderInfo">
          <el-radio-button label="" value="">全部</el-radio-button>
          <el-radio-button label="createTime" value="createTime">时间</el-radio-button>
          <el-radio-button label="viewNum" value="viewNum">浏览</el-radio-button>
          <el-radio-button label="evaluateNum" value="evaluateNum">评价</el-radio-button>
        </el-radio-group>
      </div>
      <div class="works_search_three">
        <el-input
            clearable
            size="small"
            placeholder="作品名称"
            suffix-icon="el-icon-search"
            @change="search"
            @clear="search"
            v-model="name">
        </el-input>
      </div>
    </div>
    <div class="active_works_list" v-loading="loading">
      <div class="list_box"
           v-for="(items,index) in tableData"
           :key="index"
           v-if="tableData.length>0"
           @click="worksDetails(items.uuid)">
        <img :src="items.coverUrl" alt="" class="list_box_img">
        <div class="box_img_mes">
          <p class="list_box_title">{{items.name}}</p>
          <span class="list_box_time">{{items.createTime}}</span>
          <div class="list_box_icon">
            <p>
              <i class="iconfont">&#xe611;</i>{{ numfix(items.viewNum) }}
            </p>
            <p>
              <i class="iconfont iconfont_two">&#xe639;</i>{{ numfix(items.thumbNum) }}
            </p>
            <p>
              <i class="iconfont">&#xe60d;</i>{{ numfix(items.evaluateNum) }}
            </p>
          </div>
          <div class="list_box_user">
            <img :src="items.headUrl?items.headUrl: require('@/assets/users.png')" alt="" />
            <p>{{items.nickName}}</p>
          </div>
        </div>
      </div>
      <div class="list_box" v-if="tableData.length==0">
        <p class="list_boxP">暂无数据</p>
      </div>
    </div>
    <el-pagination
            background
            @current-change="handleCurrentChange"
            @prev-click="handleCurrentChange"
            @next-click="handleCurrentChange"
            layout="total,prev, pager, next,jumper"
            :current-page="current"
            :page-size="pageSize"
            :total="total" class="pagination">
    </el-pagination>
  </div>
</template>
<script>
  import { getActivityTypeList, getActivityWayList, getWorksList } from '../../../utils/interface';
  export default {
    data(){
      return {
        activityWayUuid:"",
        wayList:[],
        typeUuid:"",
        typeList:[],
        activityUuid:"",
        value:'',
        radio:'',
        name:'',
        tableData: [],
        current: 1,
        pageSize: 12,
        total: 0,
        orderBy:"",
        loading: false,
      }
    },
    methods: {
      init(uuid,bannerRefHeight){
        this.activityUuid = uuid;
        this.bannerRefHeight = bannerRefHeight
        getActivityWayList({activityUuid:uuid}).then((res)=>{
          this.wayList = res;
        });
        this.getWorksList();
      },
      getTypeInfo(){
        this.typeList = [];
        this.typeUuid = "";
        getActivityTypeList({activityWayUuid: this.activityWayUuid}).then((res) => {
          this.typeList = res.data;
        });
        this.search();
      },
      getWorksList(){
        this.loading = true
        let params = {
          status:"PASS",
          name:this.name,
          orderBy:this.orderBy,
          typeUuid:this.typeUuid,
          activityWayUuid:this.activityWayUuid,
          isAward:true,
          activityUuid:this.activityUuid,
          current:this.current,
          pageSize:this.pageSize
        };
        getWorksList(params).then((res)=>{
          this.total = res.total;
          res.list.forEach(items => {
            items.headUrl? items.headUrl : items.headUrl = require('../../../assets/users.png')
          })
          this.tableData = res.list;
          this.loading = false
        });
      },
      // 分页
      handleCurrentChange(val){
        this.current = val;
        window.scrollTo({ 
          top: this.bannerRefHeight, 
          behavior: "smooth" 
        });
        this.getWorksList();
      },
      // 排序
      getOrderInfo(){
        if(this.radio==''){
          this.orderBy = '';
        }else {
          this.orderBy = this.radio + "_descend";
        }
        this.search();
      },
      search(){
        this.current = 1;
        this.getWorksList();
      },
      worksDetails(uuid){
        let routeData = this.$router.resolve({
          name: "worksDetails",
          params: { uuid: uuid,activityUuid:this.activityUuid },
        });
        window.open(routeData.href, "_blank");
        // this.$router.push({ name: "worksDetails", params: { uuid: uuid,activityUuid:this.activityUuid } });
      },
      numfix(num) {
        return num / 10000 >= 1
                ? (num / 10000).toFixed(2) + "w"
                : num / 1000 >= 1
                        ? (num / 1000).toFixed(2) + "k"
                        : num;
      }
    },
  }
</script>
<style scoped lang="less">
  .active_works {
    width: 1200px;
    margin: 0 auto;
    background: rgba(255, 255, 255);
    border: 1px solid #EFEFEF;
    border-radius: 10px;
    margin-top: 25px;
    padding: 21px 20px;
    box-sizing: border-box;
    .active_works_list {
      display: flex;
      align-items: center;
      flex-wrap: wrap;
      .list_box {
        margin-right: 20px;
        width: 274px;
        border-radius: 4px 4px 0px 0px;
        margin-bottom: 21px;
        cursor: pointer;
        &:nth-of-type(4n+4){
          margin-right: 0;
        }
        .list_boxP {
          font-size: 14px;
          color: #aeaeae;
          cursor: default;
        }
        .list_box_img {
          height: 171px;
          width: 100%;
          border-radius: 4px 4px 0px 0px;
          display: block;
        }
        .box_img_mes {
          padding: 10px 15px 12px;
          width: 274px;
          height: 139px;
          background: rgba(249, 249, 249);
          box-sizing: border-box;
          .list_box_title {
            font-size: 14px;
            color: #3D3D3D;
          }
          .list_box_time {
            font-size: 12px;
            color: #cecece;
            margin-bottom: 3px;
            display: inline-block;
          }
          .list_box_icon {
            display: flex;
            align-items: center;
            font-size: 10px;
            margin-bottom: 9px;
            p {
              display: flex;
              align-items: center;
              margin-right: 39px;
              color: #A9AFB8;
              i {
                margin-right: 2px;
                color: #A9AFB8;
                margin-top: 3px;
              }
              .iconfont_two {
                margin-top: 0;
              }
            }
          }
          .list_box_user {
            border-top: 1px solid #F5F5F5;
            display: flex;
            align-items: center;
            padding-top: 12px;
            img {
              width: 28px;
              height: 28px;
              border-radius: 50%;
              margin-right: 8px;
            }
            p {
              font-size: 12px;
              color: #111111;
            }

          }
        }
      }
    }
    /deep/.el-pagination {
      text-align: right;
    }
    .active_works_search {
      display: flex;
      align-items: center;
      justify-content: end;
      font-size: 14px;
      margin: 14px 0 20px;
       .search{
        margin-right: 20px;
      }
      .works_search_one {
        display: flex;
        align-items: center;
        p {
          margin-right: 8px;
        }
        /deep/.el-input__icon {
          line-height: 32px;
        }
        /deep/.el-input--suffix .el-input__inner {
          height: 32px;
        }
      }
      .works_search_two {
        margin: 0 20px ;
      }
    }
  }

</style>



// WEBPACK FOOTER //
// src/components/design/activeList/activeWinDetail.vue